import { InfoOutline } from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";
import { useProgress } from "context/ProgressProvider";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  AppFormikTextField,
  AppPrimaryButton,
  BlackTooltip,
} from "shared/components/AppComponents";
import { BankSchema, SolicitorSchema } from "shared/helpers/Schema";
import UploadDocuments from "./upload/UploadDocuments";
import { ProfileActions } from "state/profile/Action";
import { LoanService } from "services/LoanService";
import Utils, { DefaultPagination } from "shared/helpers/Utils";

const SolicitorDetails = () => {
  const { handleCompleteAndNext, currentProfile, isBroker } = useProgress();
  const dispatch = useDispatch();

  const handleAddSolicitorDetails = (value, formik) => {
    if (currentProfile.isAllowedToEdit) {
      if (!currentProfile.isAllowedToEdit?.solicitorDetails) {
        handleCompleteAndNext();
        return;
      }
    }

    LoanService.addSolicitorDetails(
      {
        firstName: value.solicitorfirstName,
        lastName: value.solicitorLastName,
        email: value.solicitorWorkEmailAddress,
        businessName: value.solicitorBusinessName,
      },
      currentProfile.loadId,
    )
      .then((response: any) => {
        handleCompleteAndNext();
      })
      .catch((error: any) => {
        Utils.handleErrorResponse(error);
      })
      .finally(() => {
        formik?.setSubmitting(false);
      });
  };

  const handleSubmitForm = (value, formik) => {
    formik?.setSubmitting(true);
    console.log(value);
    dispatch(ProfileActions.setSblProfile(value));
    handleAddSolicitorDetails(value, formik);
  };

  return (
    <>
      <Box>
        <Typography variant="h2">
          Solicitor details{" "}
          <BlackTooltip title="A solicitor can witness and execute documents to speed up settlement.">
            <InfoOutline fontSize={"small"} sx={{ marginLeft: "10px" }} />
          </BlackTooltip>
        </Typography>
        <Typography variant="h3" fontWeight={400}>
          {isBroker ? (
            <>
              As the documents will require a witness and often legal execution,
              we have decided to simplify this process to allow your customer
              Solicitor to act in both circumstances in order to reduce time to
              settlement.
            </>
          ) : (
            <>
              As the documents will require a witness and often legal execution,
              we have decided to simplify this process to allow your Solicitor
              to act in both circumstances in order to reduce time to
              settlement.
            </>
          )}
        </Typography>

        <Box sx={{ marginTop: "2rem" }}></Box>
        <Formik
          enableReinitialize
          validationSchema={SolicitorSchema}
          validateOnMount
          onSubmit={(formValues, formik) => {
            handleSubmitForm(formValues, formik);
          }}
          initialValues={{
            solicitorfirstName: currentProfile.solicitorfirstName,
            solicitorLastName: currentProfile.solicitorLastName,
            solicitorBusinessName: currentProfile.solicitorBusinessName,
            solicitorWorkEmailAddress: currentProfile.solicitorWorkEmailAddress,
          }}
        >
          {({ handleSubmit, errors, isSubmitting }) => {
            console.log(errors);
            return (
              <form autoComplete="off">
                <Box>
                  <Grid container spacing={4}>
                    <Grid size={{ xs: 12, md: 6 }} component="div">
                      <AppFormikTextField
                        placeholder="First name"
                        label="First name"
                        name="solicitorfirstName"
                        outerLabel
                        className="ezifin-default-field"
                      />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }} component="div">
                      <AppFormikTextField
                        placeholder="Last name"
                        label="Last name"
                        name="solicitorLastName"
                        outerLabel
                        className="ezifin-default-field"
                      />
                    </Grid>
                  </Grid>
                </Box>

                <Box mt={3}>
                  <AppFormikTextField
                    placeholder="Business name"
                    label="Business name"
                    name="solicitorBusinessName"
                    outerLabel
                    className="ezifin-default-field"
                  />
                </Box>

                <Box mt={3}>
                  <AppFormikTextField
                    placeholder="Work email address"
                    label="Work email address"
                    name="solicitorWorkEmailAddress"
                    outerLabel
                    className="ezifin-default-field"
                  />
                </Box>

                <Box mt={3}>
                  <AppPrimaryButton
                    title="Continue"
                    isLoading={isSubmitting}
                    loadingText="Please wait.."
                    onClick={handleSubmit}
                    disabled={Object.keys(errors).length > 0 || isSubmitting}
                  />
                </Box>
              </form>
            );
          }}
        </Formik>
      </Box>
    </>
  );
};

export default SolicitorDetails;
